import React from "react";

const IntlTransfersOptions = (props) => {
  const options = [
    {
      text: 'Which countries can I send money to?',
      handler: props.actionProvider.handleIntlTransfersOptions1,
      id: 1,
    },
    {
      text: 'How do I send an International Transfer by Mastercard and Interac?',
      handler: props.actionProvider.handleIntlTransfersOptions2,
      id: 2
    },
    {
      text: 'What is an IBAN number?',
      handler: props.actionProvider.handleIntlTransfersOptions3,
      id: 3
    },
    {
      text: 'Is there a fee and limit for International Transfer by Mastercard and Interac?',
      handler: props.actionProvider.handleIntlTransfersOptions4,
      id: 4
    },
    {
      text: 'What is the foreign exchange rate that will be charged?',
      handler: props.actionProvider.handleIntlTransfersOptions5,
      id: 5
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container intltransfer-products'>{optionsMarkup}</div>;
};

export default IntlTransfersOptions;